import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import { compose } from 'recompose'
import { ActivityState } from 'containers/forms/activities'
import { AssessorReportBlock } from 'containers/sections/assessors'
import { Logs } from 'containers/forms/logs'
import { BadgesOverview } from 'containers/sections/badges'
import { FormButton, FloatingBar } from 'components/misc'
import { Form } from 'components/layout'
import { ActivityDetailLoader } from 'components/loaders'
import { ActivityDetail } from 'components/sections/activities'
import { form } from 'helpers/decorators'
import { apiActions, apiAwards, apiConfiguration, apiAssessors, apiCodeLists } from 'helpers/decorators/api'
import {
  TasksActivitiesTableSingle,
  TasksSectionsTableSingle
} from 'components/sections/tasks'
import { PROGRESS_STATES } from 'constants/enums'
import { validateSection } from 'models/activities'
import { AwardSetMajorWarningModal } from 'components/modals'
import { connect } from 'react-redux'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'
import assessorsDropdownSelector from '../../../../redux/selectors/assessors/assessorsDropdownSelector'
import { isAssessorManagementEnabledForActivity } from '../../../../helpers/assessorHelper'

const asyncValidate = (val, dispatch, props) => {
  const { values } = props

  const isAssessorManagementEnabled = get(props, 'isAssessorManagementEnabled')

  if (!isAssessorManagementEnabled) {
    return new Promise(resolve => resolve())
  }

  const activityCategoryId = get(values, 'activityCategory.id')

  if (!get(values, 'assessorEmail') || (!activityCategoryId || activityCategoryId === 'OTHER')) {
    return new Promise(resolve => resolve())
  }

  const email = get(values, 'assessorEmail')

  const orgId = get(props, 'award.organization.id')

  return email && orgId && activityCategoryId && props.checkAssessorEmailAvailability(email, orgId, activityCategoryId)
      .then(body => {
        if (!get(body, 'body.available')) {
          const bodyObj = get(body, 'body')

          let assessor = ''

          get(bodyObj, 'assessorList').forEach(a => {
            assessor += get(a, 'name') + ' '
          })
          // eslint-disable-next-line
          throw {
            assessorEmail:
                {
                  text: `Assessor ${assessor} already exists, select him/her from the list.`,
                  intlKey: 'errors.assessor_already_exists'
                }

          }
        }
      })
}


const enhance = compose(
  apiAssessors(),
  form({
    initialProps: 'data',
    disableHook: true,
    validate: validateSection,
    asyncValidate: asyncValidate
  }),
    apiActions(),
    apiCodeLists(['activityReviseReasons']),
    apiConfiguration(),
    apiAwards({ detailWithoutParam: true }),
    connect(
        ({ api }) => ({
          awards: api.awards,
          assessors: api.assessors,
        }),
        {}
    )
)

class Activity extends Component {
  static propTypes = {
    route: PropTypes.object,
    data: PropTypes.object,
    awardValidations: PropTypes.object,
    sectionState: PropTypes.object,
    awardState: PropTypes.object,
    values: PropTypes.object,
    activities: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    updateActivity: PropTypes.func.isRequired,
    setupActivity: PropTypes.func.isRequired,
    approveActivity: PropTypes.func.isRequired,
    returnActivity: PropTypes.func.isRequired,
    signoffActivity: PropTypes.func.isRequired,
    returnSignoffActivity: PropTypes.func.isRequired,
    changeActivityState: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    changeActivityAssessor: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    onRestoreActivity: PropTypes.func,
    isMultiple: PropTypes.bool,
    isParentLoading: PropTypes.bool,
    isOffline: PropTypes.bool,
    isAssessorDetailMandatory: PropTypes.bool,
    isAssessorWelcomeEmailEnabled: PropTypes.bool,
    isMessagingEnabled: PropTypes.bool,
    isBadgesEnabled: PropTypes.bool,
    isBadgesStrictModeEnabled: PropTypes.bool,
    award: PropTypes.object.isRequired,
    getParticipantActions: PropTypes.func,
    actions: PropTypes.object,
    awards: PropTypes.object,
    configuration: PropTypes.object.isRequired,
    onGetConfigurationValue: PropTypes.func.isRequired,
    isAssessorManagementEnabled: PropTypes.bool.isRequired,
    assessors: PropTypes.array,
    onGetAvailableAssessorsForActivityCategory: PropTypes.func,
    orgId: PropTypes.number.isRequired,
    codeLists: PropTypes.object.isRequired,
    checkAssessorEmailAvailability: PropTypes.func.isRequired
  }

  async componentDidMount() {
    const actionId = get(this.props, 'data.activityAssessmentActionId')

    const participantId = get(this.props, 'award.participant.id')

    await actionId && participantId && this.props.getParticipantActions('', `id=${actionId}`, participantId)

    const orgId = get(this.props, 'award.organization.id')

    orgId && this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isAssessorReportAdditionalInfoEnabled.id, orgId)
  }

  componentWillReceiveProps(nextProps) {
    const { award } = this.props

    if (
        get(award, 'organization.id') !==
        get(nextProps.award, 'organization.id')
    ) {
      const orgId = get(nextProps.award, 'organization.id')

      orgId && this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isAssessorReportAdditionalInfoEnabled.id, orgId)

    }
  }

  handleMajorValidateChange = (newValue, validCallback) => {
    if (newValue
      && get(this.props.awardValidations, 'warnAddingMajorActivity')) {
      this.props.modal('award-set-major-warning-modal')
    } else {
      validCallback()
    }
  }

  handleMajorSetConfirmed = () => {
    this.props.change('isMajor', true)
    this.props.modal(null)
  }

  render() {
    const {
      data,
      handleSubmit,
      updateActivity,
      setupActivity,
      activities,
      values,
      approveActivity,
      returnActivity,
      signoffActivity,
      returnSignoffActivity,
      changeActivityState,
      route,
      isMultiple,
      onRestoreActivity,
      isParentLoading,
      sectionState,
      isOffline,
      awardState,
      isAssessorDetailMandatory,
      isAssessorWelcomeEmailEnabled,
      isMessagingEnabled,
      isBadgesEnabled,
      isBadgesStrictModeEnabled,
      codeLists,
      award,
      actions,
      awards,
      configuration,
      assessors,
      onGetAvailableAssessorsForActivityCategory
    } = this.props



    const assessorDetailMandatoryPermittedActivityStates = [
      PROGRESS_STATES.activitySetup.id,
      PROGRESS_STATES.participantApproved.id
    ]

    let assessorList = assessorsDropdownSelector(assessors, this.props)

    const assessorId = get(data, 'assessor.id')

    assessorList = assessorId && assessorList.filter(a => get(a, 'value') !== assessorId) || assessorList

    const isAssessmentPositive = get(data, 'isAssessmentPositive')

    const isCompleted = (get(data, 'completed') / 3600) >= (get(data, 'total') / 3600)

    const validationData = { isAssessmentPositive, isCompleted }

    const showAssessorPanel = !isAssessorDetailMandatory || (isAssessorDetailMandatory && !assessorDetailMandatoryPermittedActivityStates.includes(get(sectionState, 'value')))

    const state = get(data, 'awardState') || awardState

    const canEdit = get(state, 'value') !== PROGRESS_STATES.awardRegApproval.id

    const orgId = get(award, 'organization.id')

    const isAssessorReportAdditionalInfoEnabled = get(configuration, `valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.isAssessorReportAdditionalInfoEnabled.id}].booleanValue`)

    const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(data)

    const componentApproval = (
      <TasksActivitiesTableSingle
        data={data}
        approveModal={approveActivity}
        returnModal={returnActivity}
        modal={this.props.modal}
        isAssessorWelcomeEmailEnabled={isAssessorWelcomeEmailEnabled}
        isAssessorManagementEnabled={isAssessorManagementEnabled}
        validationData={validationData}
        codeLists={codeLists}
      />
    )
    const componentSignoff = (
      <TasksSectionsTableSingle
        data={data}
        approveModal={signoffActivity}
        returnModal={returnSignoffActivity}
        modal={this.props.modal}
        validationData={validationData}
      />
    )
    const inSetupMode =
      PROGRESS_STATES.activitySetup.id === get(data.activityState, 'value')

    return (
      <Form
        onSubmit={handleSubmit(
          fields =>
            (inSetupMode
              ? setupActivity(data.id, fields)
              : updateActivity(data.id, fields))
        )}
        loading={activities.loading}
        contentLoader={<ActivityDetailLoader />}
      >
        {!canEdit &&
        <FormattedMessage
          id="activity.cannot_edit_activity_if_award_in_state"
          defaultMessage="Cannot edit activity if award is in {state} state"
          values={{
            state: <strong>{get(state, 'translationText')}</strong>
          }}
        />}
        {isOffline &&
        <FormattedHTMLMessage
          id="activity.cannot_edit_activity_offline"
          defaultMessage="You cannot edit activity if Award is in offline mode"
        />}
        {data &&
        (canEdit && !isOffline) &&
        <div>
          <div className="row">
            <div className="col-xs-12">
              {get(data, 'id') &&
              <ActivityState
                activityId={get(data, 'id')}
                activityState={sectionState}
                hasOneActivity={!isMultiple}
                changeActivityState={changeActivityState}
                componentApproval={componentApproval}
                componentSignoff={componentSignoff}
                onRestoreActivity={onRestoreActivity}
                validationData={validationData}
              />}
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              {get(data, 'id') && showAssessorPanel &&
              <AssessorReportBlock
                id={data.id}
                data={data}
                award={award}
                actionId={data.activityAssessmentActionId}
                isAssessmentPositive={data.isAssessmentPositive}
                assessmentActionId={data.activityAssessmentActionId}
                returnedToParticipant={data.returnedToParticipant}
                changeAssessor={this.props.changeActivityAssessor}
                isActivity
                state={get(data, 'activityState')}
                isAssessorDetailMandatory={isAssessorDetailMandatory}
                isAssessorWelcomeEmailEnabled={isAssessorWelcomeEmailEnabled}
                isAssessorReportAdditionalInfoEnabled={isAssessorReportAdditionalInfoEnabled}
                isAssessorManagementEnabled={isAssessorManagementEnabled}
                assessorsList={assessorList}
                values={values}
                actions={actions.list}
              />}
            </div>
          </div>
          <div className="row" >
            <div className="col-xs-3">
              {get(data, 'activitySection.value') &&
              <ActivityDetail
                activities={activities}
                values={values}
                activityState={sectionState}
                section={get(data, 'activitySection.value')}
                initialize={this.props.initialize}
                change={this.props.change}
                data={data}
                validateMajorChange={this.handleMajorValidateChange}
                isAssessorDetailMandatory={isAssessorDetailMandatory}
                isAssessorManagementEnabled={isAssessorManagementEnabled}
                assessorList={assessorList}
                onGetAvailableAssessorsForActivityCategory={onGetAvailableAssessorsForActivityCategory}
                orgId={orgId}
              />}
              <AwardSetMajorWarningModal
                modalId="award-set-major-warning-modal"
                onProceed={this.handleMajorSetConfirmed}
              />
            </div>
            <div className="col-xs-9">

                { isBadgesEnabled && <div><div className="row">
                    <div className="col-xs-6">
                        <h2>
                            <FormattedMessage
                                id="moduleTitle.badges"
                                defaultMessage="Badges"
                            />
                        </h2>
                    </div>

                </div>
                    <BadgesOverview decoAwardId={award.id} award={award} awards={awards} activity={data} isBadgesStrictModeEnabled={isBadgesStrictModeEnabled} />
                </div>}

              <div className="row" style={{ clear: 'both' }}>
                <div className="col-xs-6">
                  <h2>
                    <FormattedMessage
                      id="moduleTitle.logs"
                      defaultMessage="Logs"
                    />
                  </h2>
                </div>
                <div className="col-xs-6 text--right">
                  <p>
                    {get(data, 'total')
                      ? `${data.completed / 3600} / ${data.total / 3600} h`
                      : ''}
                  </p>
                </div>
              </div>
              {data.id &&
              <Logs
                activityId={data.id}
                route={route}
                activityState={get(data, 'activityState')}
                isParentLoading={isParentLoading}
                award={award}
                isMessagingEnabled={isMessagingEnabled}
                configuration={configuration}
              />}
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 text--right">
              <FloatingBar>
                <FormButton {...this.props} disabled={!canEdit}>
                  <FormattedMessage
                    id={inSetupMode ? 'button.setup' : 'button.save'}
                    defaultMessage={inSetupMode ? 'Setup' : 'Save'}
                  />
                </FormButton>
              </FloatingBar>
            </div>
          </div>
        </div>}
        {!data &&
        <h2>
          <FormattedMessage id="award.no_data" defaultMessage="No data" />
        </h2>}
      </Form>
    )
  }
}

export default enhance(Activity)
